(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["basic-image"] && !Shopify.designMode) return;
  try {
    (() => {
    const states = new WeakMap();
    function stateFor(image) {
      let state = states.get(image);
      if (!state) {
        state = { attempts: 0, pending: false, manual: false, source: '', originalSrcset: image.getAttribute('srcset'), originalSizes: image.getAttribute('sizes') };
        states.set(image, state);
      }
      return state;
    }
    function display(image, status) {
      const root = image.closest('.basic-image');
      if (!root) return;
      root.dataset.imageState = status;
      root.setAttribute('aria-busy', String(status === 'loading'));
      const button = root.querySelector('.basic-image__status');
      if (button) {
        button.disabled = status !== 'error';
        button.textContent = status === 'error' ? button.dataset.errorText : button.dataset.loadingText;
      }
    }
    function loadAgain(image, state) {
      state.attempts += 1;
      // Re-select the responsive candidate without changing CDN cache keys.
      // Restore in the same task so the browser selects from the full srcset.
      const source = image.getAttribute('src');
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      if (state.originalSizes) image.setAttribute('sizes', state.originalSizes);
      if (source !== null) image.setAttribute('src', source);
      if (state.originalSrcset !== null) image.setAttribute('srcset', state.originalSrcset);
    }
    function failed(image) {
      if (!(image instanceof HTMLImageElement) || !image.closest('.basic-image')) return;
      const state = stateFor(image);
      if (state.pending) return;
      state.source ||= image.currentSrc || image.src;
      if (!state.source) return;
      if (state.manual || state.attempts >= 2) { display(image, 'error'); return; }
      state.pending = true;
      display(image, 'loading');
      window.setTimeout(() => {
        state.pending = false;
        if (!image.isConnected || (image.complete && image.naturalWidth > 0)) return;
        loadAgain(image, state);
      }, 500 * (state.attempts + 1));
    }
    document.addEventListener('error', (event) => failed(event.target), true);
    document.addEventListener('load', (event) => {
      if (event.target instanceof HTMLImageElement && event.target.closest('.basic-image')) display(event.target, 'loaded');
    }, true);
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.basic-image__status');
      if (!button || button.disabled) return;
      const image = button.closest('.basic-image').querySelector('img');
      if (!image) return;
      event.preventDefault();
      const state = stateFor(image);
      state.manual = true;
      state.source ||= image.currentSrc || image.src;
      display(image, 'loading');
      loadAgain(image, state);
    });
    function scan(root = document) {
      root.querySelectorAll('.basic-image img').forEach((image) => {
        if (image.complete) {
          if (image.naturalWidth) display(image, 'loaded');
          else failed(image);
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
    else scan();
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
